// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  establishAt: string;

  constructor(establishAt: string) {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.establishAt = establishAt;
    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.split-base-on').length) {
      $('.split-base-on').removeClass('focus');

      if ($('.split-base-on').val().length === 0) {
        $('.split-base-on').removeClass('form-control-active');
      }
    }

    if (!$(event.target).closest('.split-effect-on').length) {
      $('.split-effect-on').removeClass('focus');

      if ($('.split-effect-on').val().length === 0) {
        $('.split-effect-on').removeClass('form-control-active');
      }
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
